import path from 'path'

export const navigationTitle = (siteMap, currentPath) => {
  // TODO: improve this, if there's a better way than iterating over everything, replace title function from below
  let result
  siteMap.forEach((element) => {
    if (!element) return
    if (currentPath === element.path) {
      result = element.navigationTitle || element.title
    }
    return result
  })
}

export const navigationFilter = (
  siteMap,
  currentPath,
  render,
  language,
  node,
  level,
  badges = {}
) => {
  // if (render != 'siblings' && render != 'link' && render != 'children') throw 'render should be one of siblings, link, children';
  if (
    render !== 'siblings' &&
    render !== 'link' &&
    render !== 'children' &&
    render !== 'title' &&
    render !== 'currentTitle'
  ) {
    console.warn(
      `navigationFilter.js - WARNING: render should be one of [siblings, link, title, currentTitle, children] (render:${render}, language: ${language}, node: ${node}, level:${level})`
    )
    return []
  }
  if (node) node = '/node/' + node

  const splitPath = currentPath.split(path.sep)
  let levelledPath = ''
  if (level > 0) {
    if (level > splitPath.length - 1) {
      console.warn(
        'navigationFilter.js:',
        'path level ' + level + ' not present, ignoring'
      )
      levelledPath = false
    } else {
      levelledPath = path.join(...splitPath.slice(0, level + 1))
    }
  } else if (level < 0) {
    if (Math.abs(level) > splitPath.length) {
      console.warn(
        'navigationFilter.js:',
        'path level ' + level + ' not present, ignoring'
      )
      levelledPath = false
    } else {
      levelledPath = path.join(...splitPath.slice(0, splitPath.length + level))
    }
  } else {
    levelledPath = currentPath
  }

  const pathStrippedOfLastElement = path.dirname(levelledPath)
  const nodeStrippedOfLastElement = path.dirname(node)

  let result = []
  siteMap.forEach((pageDefinition) => {
    if (!pageDefinition) return

    let badge = false
    switch (pageDefinition.node) {
      case '/node/admin/todos':
        badge = badges.todo // number of ToDos for current User
        break
      case '/node/admin/accounts/dealers':
        badge = badges.dealers // number of imported + changed + deleted dealers
        break
      case '/node/admin/inbox/orders':
        badge = badges.orders // number of not marked as done orders
        break
      case '/node/admin/products/product':
        badge = badges.products // number of imported + changed + deleted products
        break
      case '/node/admin/dashboard':
        badge =
          badges.todo +
          badges.dealers +
          badges.products +
          badges.orders +
          badges.order_requests
        break
      case '/node/admin/inbox/order-requests':
        badge = badges.order_requests // number of unread order requests
        break
      default:
      case '/node/admin/inbox/contact-requests':
        badge = badges.contact_requests // number of unread contactrequests
        break
    }
    if (
      // <Navigation render='link' node='/storefront/categories'/>
      (render === 'link' &&
        pageDefinition.node === node &&
        pageDefinition.path.match('^/' + language)) ||
      // <Navigation render='currentTitle' as='text'/>
      (render === 'currentTitle' && currentPath === pageDefinition.path) ||
      // <Navigation render='title' as='text' node='storefront/home/'/>
      (render === 'title' &&
        pageDefinition.node === node &&
        pageDefinition.path.match('^/' + language)) ||
      // <Navigation render='siblings' node='/storefront/categories'/>
      (render === 'siblings' &&
        !pageDefinition.hidden &&
        node &&
        pageDefinition.node &&
        pageDefinition.node.match(nodeStrippedOfLastElement + '/[^/]+$')) ||
      // <Navigation render='siblings' path='/de/storefront/categories'/>
      (render === 'siblings' &&
        !pageDefinition.hidden &&
        !node &&
        path &&
        pageDefinition.path &&
        pageDefinition.path.match(nodeStrippedOfLastElement + '/[^/]+$') &&
        pageDefinition.path.match('^/' + language)) ||
      // <Navigation render='siblings'/>
      (render === 'siblings' &&
        !pageDefinition.hidden &&
        pageDefinition.path &&
        pageDefinition.path.match(pathStrippedOfLastElement + '/[^/]+$')) ||
      // <Navigation render='children' path='/de/storefront/categories'/>
      (render === 'children' &&
        !pageDefinition.hidden &&
        path &&
        pageDefinition.path &&
        pageDefinition.path.match(node + '/[^/]+$')) ||
      // <Navigation render='children' node='/storefront/categories'/>
      (render === 'children' &&
        !pageDefinition.hidden &&
        node &&
        pageDefinition.node &&
        pageDefinition.node.match(node + '/[^/]+$') &&
        pageDefinition.path.match('^/' + language)) ||
      // <Navigation render='children'/>
      (render === 'children' &&
        !pageDefinition.hidden &&
        !node &&
        pageDefinition.path &&
        pageDefinition.path.match(levelledPath + '/[^/]+$'))
    ) {
      result.push({
        key: result.length,
        name: pageDefinition.node,
        path: pageDefinition.path,
        content: pageDefinition.navigationTitle || pageDefinition.title,
        icon: pageDefinition.icon,
        active: currentPath.match('^' + pageDefinition.path) !== null,
        badge,
      })
    }
  })
  return result
}



// WEBPACK FOOTER //
// ./src/lib/navigationFilter.js